import { Box, Stack, TextField, Typography } from "@mui/material";
import LoadingButton from "components/button/LoadingButton";
import { useCoutDown } from "hooks/useCountdown";
import { useSnackbar } from "notistack";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { actionLogin } from "redux/authentication";
import { AuthApi } from "service/api/auth.api";

const OTP = ({ expire, jwtToken, otpLength = 6, message }) => {
  const snackbar = useSnackbar();
  const dispatch = useDispatch();
  const loadingConfirmOTP = useSelector(
    (state) => state.auth.loadingConfirmOTP
  );

  const [value, setValue] = useState("");
  const { readableDuration, duration, reset } = useCoutDown({
    duration: expire,
  });
  const [loadingRetryOtp, setLoadingRetryOtp] = useState(false);
  const [otpMessage, setOtpMessage] = useState(message);

  const handleChangeInput = (e) => {
    const text = e.target.value;
    if (text.length > otpLength) return;

    setValue(text);
  };

  const handleReOTP = async () => {
    setLoadingRetryOtp(true);
    try {
      const { data } = await AuthApi.retryOTP({
        jwtToken: jwtToken,
      });
      setOtpMessage(data.message);
      reset(data.data?.expire);
      snackbar.enqueueSnackbar({
        message: "Đã gửi lại mã OTP",
        variant: "success",
      });
    } catch (error) {
      console.log("error", error);
    }
    setLoadingRetryOtp(false);
  };

  const isValidOtp = () => value && value.length === otpLength;

  const handleConfirmOTP = async () => {
    try {
      const { data } = await AuthApi.verifyOTP({
        otp: value,
        jwtToken: jwtToken,
      });
      dispatch(actionLogin(data));
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      if (isValidOtp()) handleConfirmOTP();
    }
  };

  return (
    <Box p={2}>
      <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
        <img
          src={`${process.env.REACT_APP_PATH}/vnpost-logo.png`}
          alt="logo"
          style={{ width: 300 }}
        />
      </Box>
      <Typography textAlign="center" fontWeight={500} mb={1}>
        Nhập mã OTP
      </Typography>

      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <TextField
          value={value}
          onChange={handleChangeInput}
          sx={{ width: 230 }}
          name="otp"
          InputProps={{
            sx: {
              fontSize: "25px",
              fontWeight: 500,
              letterSpacing: "12px",
            },
          }}
          inputProps={{
            style: { textAlign: "center" },
          }}
          onKeyDown={handleKeyDown}
          required
          variant="standard"
          autoFocus
        />
      </Box>

      <Stack
        direction="row"
        my={2}
        alignItems="center"
        spacing={8}
        justifyContent="space-between">
        <Typography>
          Thời gian còn lại:{" "}
          <Typography sx={{ fontWeight: 500 }} component="span">
            {readableDuration}
          </Typography>
        </Typography>
        <LoadingButton
          loading={loadingRetryOtp}
          onClick={handleReOTP}
          variant="outlined"
          disabled={duration !== 0}
          sx={{ width: 230 }}>
          Nhận lại mã xác thực
        </LoadingButton>
      </Stack>

      <LoadingButton
        variant="contained"
        onClick={handleConfirmOTP}
        disabled={!isValidOtp()}
        loading={loadingConfirmOTP}
        fullWidth>
        Tiếp tục
      </LoadingButton>
      {otpMessage && (
        <Typography
          mt={1}
          sx={{
            fontStyle: "italic",
            color: (theme) => theme.palette.success.main,
          }}>
          * {otpMessage}
        </Typography>
      )}
    </Box>
  );
};

export default OTP;
